import { useFormik } from "formik";
import { Edit } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { httpReauest } from "utils/httpRequest";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const UserAddress = ({ data, setData }) => {
  const { t } = useTranslation("global");
  const [editing, setEditing] = useState(false);
  const [states, setStates] = useState();
  const [cities, setCities] = useState();

  const formik = useFormik({
    initialValues: {
      state: data?.state || "",
      city: data?.city || "",
      address: data?.address || "",
      postalCode: data?.postalCode || "",
    },
    validationSchema: Yup.object({
      state: Yup.string().required(t("required")),
      city: Yup.string().required(t("required")),
      address: Yup.string().required(t("required")),
      postalCode: Yup.string().required(t("required")),
    }),
    onSubmit: async (values) => {
      const user = JSON.parse(localStorage.getItem("user"));
      await httpReauest("POST", "/user/address/" + data?._id, values, {
        "x-access-token": user?.token,
      }).then((res) => {
        setEditing(false);
        setData(res?.data?.data);
        toast.success(t("successMessage"));
      });
    },
  });

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!formik.values.city) {
      getCities();
    }
  }, [formik.values.state]);

  async function getData() {
    await fetch("https://www.iran-locations-api.ir/api/v1/fa/states").then(
      async (res) => {
        const data = await res.json();
        setStates(data);
      }
    );
  }

  async function getCities() {
    await fetch(
      "https://www.iran-locations-api.ir/api/v1/fa/cities?state=" +
        formik?.values?.state
    ).then(async (res) => {
      const data = await res.json();
      if (formik?.values?.state) {
        setCities(data[0].cities);
      } else {
        setCities(data);
      }
    });
  }

  useEffect(() => {
    formik.setValues({
      state: data?.state || "",
      city: data?.city || "",
      address: data?.address || "",
      postalCode: data?.postalCode || "",
    });
  }, [data]);

  return (
    <div className="my-6 rounded-[12px] p-3 bg-white">
      <h2 className="font-bold text-lg mb-3 flex gap-2 items-center">
        {t("addressTitle")}
        <button
          onClick={() => {
            setEditing(!editing);
            if (editing)
              formik.resetForm({
                values: {
                  state: data?.state || "",
                  city: data?.city || "",
                  address: data?.address || "",
                  postalCode: data?.postalCode || "",
                },
              });
          }}
          className="flex gap-1 items-center font-[500] bg-slate-600 text-white px-2 py-1 text-[14px] rounded"
        >
          {editing ? t("cancelButton") : t("editButton")}
          <Edit />
        </button>
      </h2>
      {editing ? (
        <form
          onSubmit={formik.handleSubmit}
          className="grid lg:grid-cols-3 gap-3 my-3"
        >
          <div className="">
            <label
              htmlFor="state"
              className="block text-sm font-medium text-gray-700"
            >
              {t("stateLabel")}
            </label>
            <select
              id="state"
              name="state"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.state}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
            >
              <option value="">{t("selectStatePlaceholder")}</option>
              {states?.map((e) => (
                <option key={e.id} value={e.name}>
                  {e.name}
                </option>
              ))}
            </select>
            {formik.touched.state && formik.errors.state ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.state}
              </div>
            ) : null}
          </div>
          <div className="">
            <label
              htmlFor="city"
              className="block text-sm font-medium text-gray-700"
            >
              {t("cityLabel")}
            </label>
            <select
              id="city"
              name="city"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.city}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
            >
              <option value="">{t("selectCityPlaceholder")}</option>
              {cities?.map((e) => (
                <option key={e.id} value={e.name}>
                  {e.name}
                </option>
              ))}
            </select>
            {formik.touched.city && formik.errors.city ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.city}
              </div>
            ) : null}
          </div>
          <div className="">
            <label
              htmlFor="postalCode"
              className="block text-sm font-medium text-gray-700"
            >
              {t("postalCodeLabel")}
            </label>
            <input
              id="postalCode"
              name="postalCode"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.postalCode}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
            />
            {formik.touched.postalCode && formik.errors.postalCode ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.postalCode}
              </div>
            ) : null}
          </div>
          <div className="">
            <label
              htmlFor="address"
              className="block text-sm font-medium text-gray-700"
            >
              {t("addressLabel")}
            </label>
            <textarea
              id="address"
              name="address"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.address}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-red-500 focus:border-red-500"
            />
            {formik.touched.address && formik.errors.address ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.address}
              </div>
            ) : null}
          </div>
          <div className="col-span-full">
            <button
              type="submit"
              className="bg-red-500 text-white px-3 py-1 rounded-[8px] hover:bg-red-700"
            >
              {t("submitButton")}
            </button>
          </div>
        </form>
      ) : (
        <div className="grid lg:grid-cols-3 gap-3 my-3">
          <div className="">
            <span className="font-bold">{t("stateLabel")}</span>
            <p>{data?.state}</p>
          </div>
          <div className="">
            <span className="font-bold">{t("cityLabel")}</span>
            <p>{data?.city}</p>
          </div>
          <div className="">
            <span className="font-bold">{t("postalCodeLabel")}</span>
            <p>{data?.postalCode}</p>
          </div>
          <div className="">
            <span className="font-bold">{t("addressLabel")}</span>
            <p className="text-gray-500">{data?.address}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserAddress;
